import React from 'react';
import {
  Card,
  CardHeader,
  CardBody
} from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import HistoryControls from '../shared/HistoryControls.js';
import { getLatestYear, getMaxHistoryLength } from '../shared/historyUtils.js';

function getLatestPoint(stats, dataPointName) {
  if(stats && stats[dataPointName]) {
    const latestYear = getLatestYear(stats[dataPointName]);
    return {
      year: latestYear,
      value: stats[dataPointName][latestYear]
    };
  }

  return null;
}

function ProvinceData({ province, provinceStats, loading }) {
  const overviewItems = [
    { label: 'Population', point: getLatestPoint(provinceStats, 'Total Population') },
    { label: 'GDP', point: getLatestPoint(provinceStats, 'GDP') },
    { label: 'Per Cap GDP', point: getLatestPoint(provinceStats, 'Per Cap GDP') },
    { label: 'Urban Population', point: getLatestPoint(provinceStats, 'Urban Population') }
  ].filter((item) => item.point);
  const availableYears = provinceStats
    ? getMaxHistoryLength(Object.keys(provinceStats).map((key) => ({ yearData: provinceStats[key] })))
    : 0;

  if(province && provinceStats) {
    return (
      <Card className="sl-data-panel sl-location-panel sl-location-panel-wide sl-explorer-read-panel">
        <CardHeader className="sl-location-panel-header">
          <div className="sl-location-header-copy">
            <div className="sl-location-header-kicker">Market Read</div>
            <div className="sl-location-header-title">{province.attributes.name}</div>
            <div className="sl-location-header-subtitle">Province profile for comparison, screening, and fast drill-down.</div>
          </div>
          <div className="sl-location-header-badge">Province · China</div>
        </CardHeader>
        <CardBody className={loading ? 'text-center' : 'p-0'}>
          {loading ? (
            <FontAwesomeIcon icon={faSpinner} size="4x" spin className="m-4 text-primary" />
          ) : (
            <div className="sl-location-panel-body">
              <div className="sl-location-overview">
                <div className="sl-location-overview-copy">
                  <div>
                    <div className="sl-location-overview-title">Quick read</div>
                    <p className="sl-location-overview-text">Use this panel as a fast executive snapshot before drilling deeper into the province metrics below.</p>
                  </div>
                  <div className="sl-location-history-meta">{availableYears > 0 ? availableYears + ' years available' : 'Recent history'}</div>
                </div>
                <div className="sl-overview-grid">
                  {overviewItems.map((item) => (
                    <div className="sl-overview-card" key={item.label}>
                      <div className="sl-overview-label">{item.label}</div>
                      <div className="sl-overview-value">{item.point.value}</div>
                      <div className="sl-overview-year">{item.point.year}</div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          )}
        </CardBody>
      </Card>
    );
  }

  return (
    <Card className="sl-data-panel sl-location-panel sl-location-panel-wide sl-explorer-read-panel">
      <CardHeader className="sl-location-panel-header">
        <div className="sl-location-header-copy">
          <div className="sl-location-header-kicker">Market Read</div>
          <div className="sl-location-header-title">Select a region to build the read</div>
          <div className="sl-location-header-subtitle">Select a province on the map to reveal a more detailed market snapshot.</div>
        </div>
      </CardHeader>
      <CardBody className="py-4">
        <div className="sl-empty-state">
          <div className="sl-empty-state-title">No market selected or search</div>
          <p className="sl-empty-state-copy mb-0">Pick a province to see top-line metrics, then narrow into prefectures with the panel on the left.</p>
        </div>
      </CardBody>
    </Card>
  );
}

export default ProvinceData;
